import type { InputTypeHiddenProps } from "~/components/Forms/Fields/Base/InputTypesProps";
import { splitProps } from "solid-js";

export function InputTypeHidden(props: InputTypeHiddenProps) {
  const [local] = splitProps(props, ["name", "value"]);
  return <input type="hidden" data-test={local.name} {...local} />;
}
